<div class="breadcrumbs">
    <span class="title">
        Dettaglio DPGR
    </span>
    <span class="title">
        <mat-icon style="vertical-align: middle;">keyboard_arrow_right</mat-icon>
        Modifica DPGR
    </span>
    <span class="title">
        <mat-icon style="vertical-align: middle;">keyboard_arrow_right</mat-icon>
        Enti Delegati
    </span>
</div>
<hr>

<div class="titolo flex-display">
    <div class="flex-display">
        <button mat-stroked-button class="pers" (click)="onNavigate('modifica-evento')">
            <mat-icon style="vertical-align: middle;">keyboard_arrow_left</mat-icon>
        </button>

        <span class="h1 upp">Enti Delegati</span>
    </div>
</div>


<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
    <mat-expansion-panel-header class="colorSearch">
        <mat-panel-title class='search'>
            <mat-icon>search</mat-icon>
            <strong class="title">CERCA</strong>
            <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="coloredS" [formGroup]="form">
        <div class="flex-row mt-5">
            <mat-form-field appearance="fill" color="accent" class="searchbar">
                <mat-label>ID Ente</mat-label>
                <input matInput formControlName="idEnte">
            </mat-form-field>

            <mat-checkbox formControlName="nuovoEnteDelegato" color="accent">
                Nuovo ente delegato
            </mat-checkbox>


            <mat-form-field appearance="fill" color='accent' class='searchbar'>
                <mat-label>Descrizione</mat-label>
                <input matInput [formControlName]="'description'">
            </mat-form-field>
        </div>
    </div>

    <mat-action-row class='colored'>
        <button mat-stroked-button class="pers2" color="warn" (click)="onReset()">Reset</button>
        <button mat-raised-button class="pers2" color="accent" (click)="filterResult()">Cerca</button>
    </mat-action-row>
</mat-expansion-panel>

<mat-table [dataSource]="dataSource" matSort matSortActive="idEnte" matSortDirection="asc" matSortDisableClear>

    <ng-container matColumnDef="idEnte">
        <mat-header-cell *matHeaderCellDef mat-sort-header> ID ENTE </mat-header-cell>
        <mat-cell [attr.data-label]="'idEnte'" *matCellDef="let element">
            {{element.idEnte}}
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header> DESCRIZIONE </mat-header-cell>
        <mat-cell [attr.data-label]="'description'" *matCellDef="let element">
            {{element.description}}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="EntiDelegati">

        <mat-header-cell *matHeaderCellDef [attr.data-label]="'Enti delegati'">
            <!--mat-checkbox class="example-margin" [checked]="allModStatoComp==='S'?true : false"
                (change)="setAllEntiDelegati($event.checked)">
            </mat-checkbox-->
            ENTI DELEGATI
        </mat-header-cell>

        <mat-cell [attr.data-label]="'Ente delegato'" *matCellDef="let element">
            <mat-checkbox class="example-margin" (change)="changeStateEntiDelegati(element)"
                [checked]="element.idEventoPcEnte && element.idEvento? true : false">
            </mat-checkbox>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<div *ngIf="this.dataSource.counter$.source['value'] === 0">
    <mat-card class="emptyTable">
        <mat-card-content>
            <h6>Non ci sono risultati</h6>
        </mat-card-content>
    </mat-card>
</div>

<mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina"
    [pageSizeOptions]="[3, 5, 10]"></mat-paginator>